import { render, staticRenderFns } from "./ProductCarousel.vue?vue&type=template&id=4d696ad9&scoped=true&"
import script from "./ProductCarousel.vue?vue&type=script&lang=ts&"
export * from "./ProductCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCarousel.vue?vue&type=style&index=0&id=4d696ad9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d696ad9",
  null
  
)

export default component.exports